import { Button } from '@shared/ui/Button';
import { Select, Label } from '@shared/ui/Input';
import type { LogistOrder, LogistTrip } from '@entities/logistics';
import { Section, SectionTitle, Card, Row, Msg, WideField } from './styles';
import { orderLabel, tripLabel } from './helpers';

interface LogistSubmitSectionProps {
  orderId: string;
  setOrderId: (id: string) => void;
  tripId: string;
  setTripId: (id: string) => void;
  orders: LogistOrder[];
  trips: LogistTrip[];
  submitting: boolean;
  enabled: boolean;
  onSubmit: () => void;
  ok: string | null;
  err: string | null;
}

export function LogistSubmitSection({
  orderId,
  setOrderId,
  tripId,
  setTripId,
  orders,
  trips,
  submitting,
  enabled,
  onSubmit,
  ok,
  err,
}: LogistSubmitSectionProps) {
  return (
    <Section>
      <SectionTitle>Отправить ЭТрН по рейсу</SectionTitle>
      <Card>
        <Row>
          <WideField $minWidth={320}>
            <Label>Заказ</Label>
            <Select
              value={orderId}
              onChange={(e) => {
                setOrderId(e.target.value);
                setTripId('');
              }}
            >
              <option value="">— выберите заказ —</option>
              {orders.map((o) => (
                <option key={o.id} value={o.id}>
                  {orderLabel(o)}
                </option>
              ))}
            </Select>
          </WideField>
          <WideField $minWidth={260}>
            <Label>Рейс</Label>
            <Select value={tripId} onChange={(e) => setTripId(e.target.value)} disabled={!orderId}>
              <option value="">— выберите рейс —</option>
              {trips.map((t) => (
                <option key={t.id} value={t.id}>
                  {tripLabel(t)}
                </option>
              ))}
            </Select>
          </WideField>
          <Button onClick={onSubmit} disabled={submitting || !enabled || !tripId}>
            Отправить ЭТрН
          </Button>
        </Row>
        {ok && <Msg>{ok}</Msg>}
        {err && <Msg $error>{err}</Msg>}
      </Card>
    </Section>
  );
}
